import { Navigate, useLocation } from "react-router-dom";
import { PropsWithChildren } from "react";
import { useAuthSlice } from "../../redux/slice/authSlice";
import { getDataFromCookies } from "../../utils/StorageUtils";

type Props = {
  fallback?: string;
};

const PublicRoute = ({ children, fallback }: PropsWithChildren<any>) => {
  const { status, isValid } = useAuthSlice();
  const location = useLocation();

  const allowedAlwaysPaths = ["/terms-2fa.html", "/privacy.html"];
  if ((status === "success") && isValid && !allowedAlwaysPaths.includes(location.pathname)) {
    if (fallback) {
      return children;
    } else {
      return <Navigate to="/" replace state={{ from: location }} />;
    }
  }

  return children;
};


export default PublicRoute;
